import React, { useState, useMemo, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Carousel.css';

function Carousel({ name, assets }) {
    const [currentIndex, setCurrentIndex] = useState(0);

      const CarouselItem = ({item, index}) => {
        if (item.type === 'image') {
            return (
                <img src={require(`../${item.path}`)} alt={`${name} project asset ${index + 1}`} className="w-auto h-full m-auto object-contain" loading="eager"/>
            );
        } else if (item.type === 'video') {
            return (
                <video controls className="w-auto max-h-[40vh] h-full m-auto object-contain">
                    <source src={require(`../${item.path}`)} type="video/mp4" title={`${name} project asset ${index + 1}`}/>
                    Your browser does not support the video tag.
                </video>
            );
        } else if (item.type === 'youtube') {
            return (
                <iframe className="youtube-player w-[80%] max-h-[40vh] h-full m-auto"
                    title={`${name} project asset ${index + 1}`}
                    src={`https://www.youtube.com/embed/${item.youtube_id}?enablejsapi=1`}
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
                    allowFullScreen>
                </iframe>
            );
        } else {
            return (
                <></>
            );
        }
    }

    const SwiperSlideContainer = useMemo(() => {
        return (
            <>
                {
                    assets.map((item, index) => (
                        <SwiperSlide key={index} className="!h-[40vh]">
                            <CarouselItem item={item} index={index}/>
                        </SwiperSlide>
                    ))
                }
            </>
        );
    }, [assets]);

    const stopVideos = () => {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
        });

        const youtubes = document.querySelectorAll('.youtube-player');
        youtubes.forEach(youtube => {
            youtube.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }

    useEffect(() => {
        stopVideos();
    }, [currentIndex]);

    return (
        <div className="relative select-none">
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                navigation={true}
                pagination={{
                    dynamicBullets: true,
                    el: '.my-custom-pagination-div',
                }}
                onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
                className="items-center justify-center"
            >
                {SwiperSlideContainer}
            </Swiper>
            <div className="flex my-4 justify-center text-center">
                <div className="my-custom-pagination-div transform-unset" />
            </div>
        </div>
    );
}

export default Carousel;